import { createSlice } from '@reduxjs/toolkit';

type IData = {
  content_size: number;
  created_at: string;
  created_by: string;
  db_id: string;
  file_host_id: number;
  hash: string;
  id: string;
  info: any;
  is_deleted: boolean;
  is_private: boolean;
  last_modified: any;
  name: string;
  size: number;
  type: string;
  content: {
    data: number[];
    type: string;
  };
};

type RequestCommandState = {
  loading: boolean;
  data: IData;
};

let data;

const initialState: RequestCommandState = {
  loading: false,
  data,
};

export const generateTemplateSlice = createSlice({
  name: 'generateTemplate',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export default generateTemplateSlice.reducer;
